<template>
  <div>
  <!-- Navigation -->
  <nav class="navbar navbar-expand-lg bg-primary text-uppercase fixed-top" id="mainNav">
    <div class="container">

        <img src="img/logo-min.png" alt="" style="width: 96px;">
      <button class="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mx-0 mx-lg-1">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger hoverr" @click="closeMenu()" href="/">HOME</a>
          </li>
          <li class="nav-item mx-0 mx-lg-1" v-if="!mostrarA">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger hoverr" style="cursor: pointer;" @click="closeMenu(); mostrarB=true; mostrarC=false; mostrarA=false; mostrarD=false;">CURSOS</a>
          </li>
          <li class="nav-item mx-0 mx-lg-1" v-if="!mostrarA && docenteIngreso[0].full">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger hoverr" style="cursor: pointer;" @click="closeMenu(); mostrarC=true; mostrarB=false; mostrarA=false; mostrarD=false;">CONFIGURACIÓN</a>
          </li>
          <li class="nav-item mx-0 mx-lg-1" v-if="!mostrarA">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger hoverr" style="cursor: pointer;" @click="closeMenu(); mostrarC=false; mostrarB=false; mostrarA=true; mostrarD=false;">Salir</a>
          </li>
         </ul>
      </div>
    </div>
  </nav>

  <section class="page-section portfolio masthead" id="portfolio" style="background-color: white !important; min-height: 600px;">
    <div class="container">


    <div v-if="mostrarA" class="text-left mt-2">
      <h2 class="text-uppercase text-left text-secondary mb-0 mt-3"> Ingreso de Docentes </h2>
      <span> Ingresa aqui tu Usuario y Contraseña.</span>

      <div class="row mt-3 justify-content-center">
        <div class="col-8 my-1">
          <form @submit.prevent="ingreso()">
            <div class="row justify-content-center">
              <label for="">Usuario</label>
              <input class="form-control mb-3" type="text" v-model="dni">
            </div>
            <div class="row justify-content-center">
              <label for="">Contraseña</label>
              <input class="form-control mb-3" type="password" v-model="clave">
            </div>
            <div class="row justify-content-center">
              <button class="btn btn-primary">
                <div v-if="!spinner"> Ingreso </div>
                <div v-else class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
              <!-- <a href="" style="font-size: 12px;">Olvide mi contraseña</a> -->
            </div>
            <!-- <div class="row justify-content-center">
              <button class="btn btn-primary">Ingresar</button>
              <a href="" style="font-size: 12px;">Olvide mi contraseña</a>
            </div> -->
          </form>
        </div>
      </div> 
    </div>
    <div v-if="mostrarB">
      <h2 class="text-uppercase text-left text-secondary mb-0 mt-3"> Docentes </h2> <br>

      <h3 class="text-uppercase text-secondary mb-0 mt-3"> Cursos </h3> <br>

      <div v-for="(itemAnio, index) in anios.filter(a => a.activo)" :key=index>
        <button class="btn btn-primary col-7 mb-2" type="button" data-toggle="collapse" :data-target="'#collapseExample'+index" aria-expanded="false" aria-controls="collapseExample">
          {{itemAnio.nombre}}
        </button>
        <div class="collapse" :id="'collapseExample'+index">

          <div v-if="docenteIngreso[0].full">
            <div v-for="(itemDocente, index) in docentes" :key=index>
              <button class="btn btn-success col-6 mb-2" type="button" data-toggle="collapse" :data-target="'#collapseDocentes'+itemAnio.nombre+index" aria-expanded="false" aria-controls="collapseDocentes">
                {{itemDocente.nombre}}
              </button>
              <div class="collapse" :id="'collapseDocentes'+itemAnio.nombre+index">
                <div v-for="(itemCurso, index) in cursos.filter(c => c.anio.uid == itemAnio.uid && c.docente.uid == itemDocente.uid )" :key=index class="row justify-content-center">
                  <button class="btn btn-dark mb-2 col-5" @click="mostrarD=!mostrarD; mostrarB=!mostrarB; mostraDetalle=false; buscarAlumnos(itemCurso.uid)"> {{itemCurso.nombre}} </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="(itemDocente, index) in docenteIngreso" :key=index>
              <button class="btn btn-success col-6 mb-2" type="button" data-toggle="collapse" :data-target="'#collapseDocentes'+itemAnio.nombre+index" aria-expanded="false" aria-controls="collapseDocentes">
                {{itemDocente.nombre}}
              </button>
              <div class="collapse" :id="'collapseDocentes'+itemAnio.nombre+index">
                <div v-for="(itemCurso, index) in cursos.filter(c => c.anio.uid == itemAnio.uid && c.docente.uid == itemDocente.uid )" :key=index class="row justify-content-center">
                  <button class="btn btn-dark mb-2 col-5" @click="mostrarD=!mostrarD; mostrarB=!mostrarB; mostraDetalle=false; buscarAlumnos(itemCurso.uid)"> {{itemCurso.nombre}} </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div v-if="mostrarD">
      <div class="row">
        <h2 class="text-uppercase text-left text-secondary mb-0 mt-3 col-10"> Docentes </h2>
        <div class="d-flex flex-row-reverse col-2">
          <button class="btn btn-secondary align-self-end" @click="mostrarD=false; mostrarB=true; cursoSeleccionado= '';">Volver</button>
        </div>
      </div>
        <br>
      
      <h3 class="text-uppercase text-secondary mb-0 mt-3"> Curso {{cursoSeleccionado.nombre}} </h3> <br>

      <div class=" row justify-content-center">
        <div class="col-6 bg-secondary pt-2 pb-2 mb-3" style="border-radius: 15px;">
          <div> Profesora: {{cursoSeleccionado.docente.nombre}} </div>
          <div> Año: {{cursoSeleccionado.anio.nombre}} </div>
        </div>
      </div>

      <div class="mb-2">
        <button class="btn btn-primary" data-placement="bottom" title="Libros" data-toggle="modal" data-target="#ModalCursoLibros" @click="agregarLibro=false;">Libros</button>
        <button class="btn btn-primary" data-placement="bottom" title="Novedades" data-toggle="modal" data-target="#ModalCursoNovedades" @click="agregarCursoNovedad=false;">Novedades</button>
        <button class="btn btn-primary" data-placement="bottom" title="Upgrade" data-toggle="modal" data-target="#ModalUpgrade" @click="cursoHasta='';buscar='';buscarAnio=''">Upgrade</button>
        <button class="btn btn-primary" data-placement="bottom" title="Detalles" data-toggle="modal" data-target="#ModalCursoDetalles" @click="mostraDetalle= !mostraDetalle;">{{mostraDetalle? 'Volver' : 'Detalles'}}</button>
      </div>
      <div class="mb-2" v-if="mostraDetalle">
        <button class="btn btn-primary" data-placement="bottom" title="PDF" @click="generarPDF();">PDF</button>
      </div>

      <table class="table table-sm" v-if="!mostraDetalle">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Marcar <input class="" type="checkbox" id="gridCheck1" v-model="selectAll" @click="marcar(!selectAll)"></th>
            <th scope="col">DNI</th>
            <th scope="col">Nombre</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in alumnosCurso" :key=item.uid>
            <td> <input class="form-check-input" type="checkbox" id="gridCheck1" v-model="item.select" @click="selectAll=false"></td>
            <td> {{item.dni}} </td>
            <td> {{item.nombre}} </td>
            <td>
              <button class="btn btn-primary" data-placement="bottom" title="Notas" data-toggle="modal" data-target="#ModalAlumnoNotas" style="height: 20px; font-size: 13px; padding-top: 0px; margin-right: 3px; " @click="seleccionAlumno = item; agregarNota=false;">Notas</button>
              <button class="btn btn-primary" data-placement="bottom" title="Observaciones" data-toggle="modal" data-target="#ModalAlumnoObservaciones" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="seleccionAlumno = item; agregarObservacion=false;">Observaciones</button>
            </td>
          </tr>
        </tbody>
      </table>
      <table :id="'my-table'+item.uid" class="table table-sm" v-for="item in alumnosCurso" :key=item.uid v-else>
        <thead class="thead-dark" >
          <tr>
            <th colspan="3">{{item.nombre}}</th>
          </tr>
          <tr>
            <th colspan="3">NOTAS</th>
          </tr>
          <tr>
            <th scope="col">Date (Fecha)</th>
            <th scope="col">Oral (Oral)</th>
            <th scope="col">Written (Escrito)</th>
          </tr>
        </thead>
        <tbody v-for="(itemNota, index) in item.notas.filter(n => n.uidCurso == cursoSeleccionado.uid)" :key="'N'+index" >
        <!-- <tbody v-for="(itemNota, index) in item.notas" :key="'N'+index" > -->
          <tr>
            <td> {{itemNota.fecha}} </td>
            <td> {{itemNota.oral}} </td>
            <td> {{itemNota.escrito}} </td>
          </tr>
          <tr v-if="itemNota.comentario != ''">
            <td colspan="3" :id="'N'+item.dni+index" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;"  > {{verSaltoLinea('N'+item.dni+index, itemNota.comentario, true )}} </td>
          </tr>
        </tbody>
        <thead class="thead-dark" v-if="item.observaciones && item.observaciones.length > 0" >
          <tr>
            <th colspan="3">OBSERVACIONES</th>
          </tr>
          <tr>
            <th scope="col">Date (Fecha)</th>
            <th scope="col" colspan="2" >Detail (Detalle)</th>
          </tr>
        </thead>
          <tbody v-for="(itemObservacion, index) in item.observaciones.filter(n => n.uidCurso == cursoSeleccionado.uid)" :key="'O'+index" >
          <!-- <tbody v-for="(itemObservacion, index) in item.observaciones" :key="'O'+index" > -->
            <tr>
              <td> {{itemObservacion.fecha}} </td>
              <td colspan="2" :id="'O'+item.dni+index"> {{verSaltoLinea('O'+item.dni+index,itemObservacion.detalle, false )}} </td>
            </tr>
          </tbody>
      </table>



      <!-- Modal -->
      <div class="modal fade" id="ModalAlumnoNotas" tabindex="-1" role="dialog" aria-labelledby="ModalAlumnoNotasTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header row">
              <h5 class="modal-title col-3" id="ModalAlumnoNotasTitle">
                <div>Notas </div>
                <div  v-if="Object.keys(seleccionAlumno).length != 0">
                {{seleccionAlumno.nombre}}
              </div></h5>
              <h3 class="text-uppercase text-primary mb-0 mt-3 col-5"> {{cursoSeleccionado.nombre}} </h3> <br>
              <button type="button" class="close col-1" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding-top: 0px;" >
              <div v-if="!agregarNota">
                <button class="btn btn-primary mb-2" @click="agregarNota=true; clear('nota') ">Agregar</button>
                <table class="table" v-if="Object.keys(seleccionAlumno).length != 0">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Date (Fecha)</th>
                      <th scope="col">Oral (Oral)</th>
                      <th scope="col">Written (Escrito)</th>
                      <th scope="col">Accion</th>
                    </tr>
                  </thead>
                    <tbody v-for="(itemNota, index) in seleccionAlumno.notas.filter(n => n.uidCurso == cursoSeleccionado.uid)" :key=index >
                    <!-- <tbody v-for="(itemNota, index) in seleccionAlumno.notas" :key=index > -->
                      <tr>
                        <td> {{itemNota.fecha}} </td>
                        <td> {{itemNota.oral}} </td>
                        <td> {{itemNota.escrito}} </td>
                        <!-- <td> {{itemNota.comentario}} </td> -->
                        <td>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Edit" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="agregarNota=true; edit('nota', itemNota)">edit</button>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Delete" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="delNotaConfirm({item:itemNota, alumno:seleccionAlumno, curso: cursoSeleccionado})">Delete</button>
                          <!-- && delNota({item:itemNota, alumno:seleccionAlumno, curso: cursoSeleccionado}) -->
                        </td>
                      </tr>
                      <tr v-if="itemNota.comentario != ''">
                        <!-- <td colspan="4" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;" > <b>Comentario:</b>  {{itemNota.comentario}} </td> -->
                        <td colspan="4" :id="'Notas'+seleccionAlumno.dni+index" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;"  > {{verSaltoLinea('Notas'+seleccionAlumno.dni+index, itemNota.comentario, true )}} </td>
                      </tr>
                    </tbody>
                </table>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="ModalAlumnoNotasTitle">Close</button>
              </div>
              <div v-else>
                <form @submit.prevent="guardar('nota','new',nota)">
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Fecha: </label>
                    <input class="form-control" type="text" id="datepickerNota">
                  </div>
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <div class="col-6">
                      <label for="">Oral: </label>
                      <input class="form-control" type="number" min="1" max="10" v-model="nota.oral">
                    </div>
                    <div class="col-6">
                      <label for="">Escrito: </label>
                      <input class="form-control" type="number" min="1" max="10" v-model="nota.escrito">
                    </div>
                  </div>
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Comentario: </label>
                    <!-- <input class="form-control" type="text" v-model="nota.comentario"> -->
                    <textarea v-model="nota.comentario" rows="4" class="form-control" ></textarea>

                  </div>
                  <br>
                  <button type="submit" class="btn btn-primary">
                    <div v-if="!spinner"> Save changes </div>
                    <div v-else class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    </button> <br>
                  <button type="button" class="btn btn-secondary" @click="agregarNota= false;">Close</button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="ModalAlumnoObservaciones" tabindex="-1" role="dialog" aria-labelledby="ModalAlumnoObservacionesTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header row">
              <h5 class="modal-title col-3" id="ModalAlumnoObservacionesTitle">
                <div>Observaciones </div>
                <div  v-if="Object.keys(seleccionAlumno).length != 0">
                {{seleccionAlumno.nombre}}
              </div></h5>
              <h3 class="text-uppercase text-primary mb-0 mt-3 col-5"> {{cursoSeleccionado.nombre}} </h3> <br>
               <button type="button" class="close col-1" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding-top: 0px;" >
              <div v-if="!agregarObservacion">
                <button class="btn btn-primary mb-2" @click="agregarObservacion=true; clear('observacion') ">Agregar</button>
                <table class="table" v-if="Object.keys(seleccionAlumno).length != 0">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Date (Fecha)</th>
                      <th scope="col">Detail (Detalle)</th>
                      <!-- <th scope="col">Written (Escrito)</th> -->
                      <th scope="col">Accion</th>
                    </tr>
                  </thead>
                    <tbody v-for="(itemObservacion, index) in seleccionAlumno.observaciones.filter(n => n.uidCurso == cursoSeleccionado.uid)" :key=index >
                    <!-- <tbody v-for="(itemObservacion, index) in seleccionAlumno.observaciones" :key=index > -->
                      <tr>
                        <td> {{itemObservacion.fecha}} </td>
                        <!-- <td> {{itemObservacion.detalle}} </td> -->
                        <td :id="'Obs'+seleccionAlumno.dni+index"> {{verSaltoLinea('Obs'+seleccionAlumno.dni+index,itemObservacion.detalle, false )}} </td>
                        <!-- <td> {{itemNota.comentario}} </td> -->
                        <td>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Edit" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="agregarObservacion=true; edit('observacion', itemObservacion)">Edit</button>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Delete" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="delObservacionConfirm({item:itemObservacion, alumno:seleccionAlumno, curso: cursoSeleccionado})">Delete</button>
                        </td>
                      </tr>
                      <!-- <tr v-if="itemNota.comentario != ''">
                        <td colspan="4" class="text-left" style="border-top-width: 0px; border-bottom: 0.125rem solid #dee2e6;" > <b>Comentario:</b>  {{itemNota.comentario}} </td>
                      </tr> -->
                    </tbody>
                </table>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="ModalAlumnoObservacionesTitle">Close</button>
              </div>
              <div v-else>
                <form @submit.prevent="guardar('observacion','new',observacion)">
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Fecha: </label>
                    <input class="form-control" type="text" id="datepickerObservacion">
                  </div>
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Observación: </label>
                    <!-- <input class="form-control" type="text" v-model="observacion.detalle"> -->
                    <textarea v-model="observacion.detalle" rows="4" class="form-control" ></textarea>

                  </div>
                  <br>
                  <!-- <button type="submit" @keydown="$event.keyCode === 13 ? $event.preventDefault() : false" class="btn btn-primary"> -->
                  <button type="submit" class="btn btn-primary">
                    <div v-if="!spinner"> Save changes </div>
                    <div v-else class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    </button> <br>
                  <button type="button" class="btn btn-secondary" @click="agregarObservacion= false;">Close</button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="ModalCursoLibros" tabindex="-1" role="dialog" aria-labelledby="ModalCursoLibrosTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalCursoLibrosTitle">
                <div>Libros </div>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding-top: 0px;" >
              <div v-if="!agregarLibro">
                <button class="btn btn-primary mb-2" @click="agregarLibro=true; clear('libro') ">Agregar</button>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Nombre</th>
                      <th scope="col">Accion</th>
                    </tr>
                  </thead>
                    <tbody v-for="(itemLibros, index) in cursoSeleccionado.libros" :key=index >
                      <tr>
                        <td> {{itemLibros.nombre}} </td>
                        <td>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Edit" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="agregarLibro=true; edit('libro', itemLibros)">edit</button>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Delete" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="delLibro({item:itemLibros, curso:cursoSeleccionado})">Delete</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="ModalCursoLibrosTitle">Close</button>
              </div>
              <div v-else>
                <form @submit.prevent="guardar('libro','new',libro)">
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Nombre: </label>
                    <input class="form-control" type="text" v-model="libro.nombre">
                  </div>
                  <br>
                  <button type="submit" class="btn btn-primary">
                    <div v-if="!spinner"> Save changes </div>
                    <div v-else class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    </button> <br>
                  <button type="button" class="btn btn-secondary" @click="agregarLibro= false;">Close</button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="ModalCursoNovedades" tabindex="-1" role="dialog" aria-labelledby="ModalCursoNovedadesTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalCursoNovedadesTitle">
                <div>Novedades </div>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding-top: 0px;" >
              <div v-if="!agregarCursoNovedad">
                <button class="btn btn-primary mb-2" @click="agregarCursoNovedad=true; clear('cursoNovedad') ">Agregar</button>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Date (Fecha)</th>
                      <th scope="col">Novedad (Novedad)</th>
                      <th scope="col">Accion</th>
                    </tr>
                  </thead>
                    <tbody v-for="(itemNovedades, index) in cursoSeleccionado.novedades" :key=index >
                      <tr>
                        <td> {{itemNovedades.fecha}} </td>
                        <!-- <td> {{itemNovedades.novedad}} </td> -->
                        <td :id="'Nov'+cursoSeleccionado.uid+index"> {{verSaltoLinea('Nov'+cursoSeleccionado.uid+index,itemNovedades.novedad, false )}} </td>

                        <td>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Edit" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="agregarCursoNovedad=true; edit('cursoNovedad', itemNovedades)">edit</button>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Delete" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="delCursoNovedad({item:itemNovedades, curso:cursoSeleccionado})">Delete</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="ModalCursoNovedadesTitle">Close</button>
              </div>
              <div v-else>
                <form @submit.prevent="guardar('cursoNovedad','new',cursoNovedad)">
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Fecha: </label>
                    <input class="form-control" type="text" id="datepickerCursoNovedad">
                  </div>
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Novedad: </label>
                    <!-- <input class="form-control" type="text" v-model="cursoNovedad.novedad"> -->
                    <textarea v-model="cursoNovedad.novedad" rows="4" class="form-control" ></textarea>
                  </div>
                  <br>
                  <button type="submit" class="btn btn-primary">
                    <div v-if="!spinner"> Save changes </div>
                    <div v-else class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    </button> <br>
                  <button type="button" class="btn btn-secondary" @click="agregarCursoNovedad= false;">Close</button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="ModalUpgrade" tabindex="-1" role="dialog" aria-labelledby="ModalUpgradeTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUpgradeTitle">
                <div>Upgrade de Curso </div>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding-top: 0px;" >
              <div>
                <form @submit.prevent="upgrade()">
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Curso Actual: {{cursoSeleccionado.nombre}} - {{cursoSeleccionado.anio.nombre}} </label>
                    <!-- <input class="form-control" type="text" id="datepickerCursoNovedad"> -->
                  </div>
                  <br>
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    Filtro : 
                    <input type="text" class="form-control col-4" v-model="buscar">
                    <div class="input-group-btn input-group-append">
                      <div class="input-group-text" style="background-color: #234c8c; cursor: pointer; color: white;" @click="buscar=''"> X </div>
                    </div>
                  </div>


                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Pasar a : </label>
                    <select class="form-control" name="" v-model="buscarAnio">
                      <option value="" disabled selected>Seleccionar Año</option>
                      <option v-for="itemAnio in ListaAnios" :key=itemAnio.nombre :value="itemAnio.nombre">{{itemAnio.nombre}}</option>
                    </select>
                    <select class="form-control" name="" v-model="cursoHasta">
                      <option value="" disabled selected>Seleccionar Curso</option>
                      <option v-for="itemCurso in cursosConfig.filter(e => (e.nombre.toUpperCase().indexOf(buscar.toUpperCase()) != -1 || e.docente.nombre.toUpperCase().indexOf(buscar.toUpperCase()) != -1) && e.anio.nombre == buscarAnio )" :key=itemCurso.uid :value="itemCurso">{{itemCurso.nombre}} - {{itemCurso.anio.nombre }} ({{itemCurso.docente.nombre}})</option>
                    <!-- <option v-for="itemCurso in cursosConfig" :key=itemCurso.uid :value="itemCurso">{{itemCurso.nombre}} - {{itemCurso.anio.nombre }} ({{itemCurso.docente.nombre}})</option> -->
                    </select>
                  </div>
                  <br>
                  <button type="submit" class="btn btn-primary">
                    <div v-if="!spinner"> Save changes </div>
                    <div v-else class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    </button> <br>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="mostrarC">   <!-- Opcion Docentes * Configuracion -> Anio -->
      <h2 class="text-uppercase text-left text-secondary mb-0 mt-3"> Docentes </h2> <br>

      <h3 class="text-uppercase text-secondary mb-0 mt-3"> Configuración </h3> <br>

      <div class="row justify-content-center">
      <ul class="nav nav-pills mb-2 justify-content-center" id="pills-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link" id="pills-anios-tab" data-toggle="pill" href="#pills-anios" role="tab" aria-controls="pills-anios" aria-selected="true" @click=" buscar='';">Año Lectivo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="pills-docentes-tab" data-toggle="pill" href="#pills-docentes" role="tab" aria-controls="pills-docentes" aria-selected="false" @click=" buscar='';">Docentes</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="pills-cursos-tab" data-toggle="pill" href="#pills-cursos" role="tab" aria-controls="pills-cursos" aria-selected="false" @click=" getAlumnos(); buscar='';">Cursos</a>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" id="pills-alumnos-tab" data-toggle="pill" href="#pills-alumnos" role="tab" aria-controls="pills-alumnos" aria-selected="false" @click="getLecturaAlumnos(); buscar='';">Alumnos</a> -->
          <a class="nav-link" id="pills-alumnos-tab" data-toggle="pill" href="#pills-alumnos" role="tab" aria-controls="pills-alumnos" aria-selected="false" @click="getAlumnos(); buscar='';">Alumnos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="pills-novedades-tab" data-toggle="pill" href="#pills-novedades" role="tab" aria-controls="pills-novedades" aria-selected="false" @click="getNovedades(); buscar='';">Novedades</a>
        </li>
      </ul>
        <div class="col-11">
          <div class="tab-content mt-3 mb-5" id="pills-tabContent">
            <div class="tab-pane fade" id="pills-anios" role="tabpanel" aria-labelledby="pills-anios-tab">
              <!-- <button class="btn btn-primary mb-3">Agregar</button> -->
              <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#ModalAnio" @click="clear('anio')">
                Agregar
              </button>
              <table class="table table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Año</th>
                    <th scope="col">Activo</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in anios" :key=item.uid>
                    <td> {{item.nombre}} </td>
                    <td> {{item.activo ?'Si':'No'}} </td>
                    <td>
                      <button class="btn btn-warning" data-placement="bottom" title="Editar" data-toggle="modal" data-target="#ModalAnio" @click="seleccionar('anio', item)" style="height: 20px; font-size: 13px; padding-top: 0px; ">Edit</button>
                      <button class="btn btn-danger"  data-toggle="tooltip" data-placement="bottom" title="Eliminar" @click="eliminar('anio', item);" style="height: 20px; font-size: 13px; padding-top: 0px; ">Delete</button>
                      <button class="btn btn-success"  data-toggle="tooltip" data-placement="bottom" title="Historico" @click="historico(item);" style="height: 20px; font-size: 13px; padding-top: 0px; " v-if="!item.historico">Generar Historico</button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Modal -->
              <div class="modal fade" id="ModalAnio" tabindex="-1" role="dialog" aria-labelledby="ModalAnioTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="ModalAnioTitle">
                        <div v-if="anio.uid == undefined">Agregar</div>
                        <div v-else>Modificar</div></h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">

                      <form @submit.prevent="guardar('anio',anio.uid ? 'edit':'new',anio)">
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Año: </label>
                          <input class="form-control" v-model="anio.nombre" type="number">
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <div class="col-sm-6">Activo</div>
                          <div class="col-sm-6">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="gridCheck1" v-model="anio.activo">
                              <label class="form-check-label" for="gridCheck1">
                                <span v-if="anio.activo">Si</span>
                                <span v-else>No</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="row m-auto mb-1 col-10 justify-content-center">
                          <label for="">Vigente </label>
                          <input class="form-control" type="text">
                        </div> -->
                        <br>
                        
                        <button type="submit" class="btn btn-primary" @click="spinner=!spinner">
                          <div v-if="!spinner"> Save changes </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                          </button> <br>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" id="closeAnio">Close</button>
                      </form>
                    </div>
                    <!-- <div class="modal-footer">
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-docentes" role="tabpanel" aria-labelledby="pills-docentes-tab">
              <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#ModalDocente" @click="clear('docente')">
                Agregar
              </button>
              <div class="col-4 filtro"> 
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Filtro</div>
                  </div>
                  <input type="text" class="form-control" v-model="buscar">
                <div class="input-group-btn input-group-append">
                  <div class="input-group-text" style="background-color: #234c8c; cursor: pointer; color: white;" @click="buscar=''"> X </div>
                </div>
                </div>
              </div>
              <table class="table table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">DNI</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in docentes.filter(e => e.nombre.toUpperCase().indexOf(buscar.toUpperCase()) != -1 || e.dni.toUpperCase().indexOf(buscar.toUpperCase()) != -1 )" :key=item.uid>
                    <td> {{item.dni}} </td>
                    <td> {{item.nombre}} </td>
                    <td>
                      <button class="btn btn-warning" data-placement="bottom" title="Editar" data-toggle="modal" data-target="#ModalDocente" @click="seleccionar('docente', item)" style="height: 20px; font-size: 13px; padding-top: 0px; ">Edit</button>
                      <button class="btn btn-danger"  data-toggle="tooltip" data-placement="bottom" title="Eliminar" @click="eliminar('docente', item);" style="height: 20px; font-size: 13px; padding-top: 0px; ">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </table>

                            <!-- Modal -->
              <div class="modal fade" id="ModalDocente" tabindex="-1" role="dialog" aria-labelledby="ModalDocenteTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="ModalDocenteTitle">
                        <div v-if="docente.uid == undefined">Agregar</div>
                        <div v-else>Modificar</div></h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">

                      <form @submit.prevent="guardar('docente',docente.uid ? 'edit':'new',docente)">
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">DNI: </label>
                          <input class="form-control" type="number" v-model="docente.dni">
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Nombre: </label>
                          <input class="form-control" type="text" v-model="docente.nombre">
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Clave: </label>
                          <input class="form-control" :type="mostrarClave ? 'text':'password'" v-model="docente.clave">
                          <button type="button" class="btn btn-primary" style="height: 25px; padding-top: 0px; padding-bottom: 0px;" @click="mostrarClave=!mostrarClave"> 
                            <span v-if="!mostrarClave">Mostrar</span> 
                            <span v-else>Ocultar</span> </button>
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <div class="col-sm-2">Activo</div>
                          <div class="col-sm-10">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="gridCheck1" v-model="docente.activo">
                              <label class="form-check-label" for="gridCheck1">
                                <span v-if="docente.activo">Activo</span>
                                <span v-else>No Activo</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <div class="col-sm-2">Permiso Full</div>
                          <div class="col-sm-10">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="gridCheck2" v-model="docente.full">
                              <label class="form-check-label" for="gridCheck2">
                                <span v-if="docente.full">Si</span>
                                <span v-else>No, Solo sus Cursos</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <br>
                        
                        <button type="submit" class="btn btn-primary" @click="spinner=!spinner">
                          <div v-if="!spinner"> Save changes </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                          </button> <br>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" id="closeDocente">Close</button>
                      </form>
                    </div>
                    <!-- <div class="modal-footer">
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-cursos" role="tabpanel" aria-labelledby="pills-cursos-tab">
              <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#ModalCurso" @click="clear('curso')">
                Agregar
              </button>
              <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#ModalDuplicarCurso" @click="clear('duplicarCurso')">
                Duplicar
              </button>
              <div class="col-4 filtro">
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Filtro</div>
                  </div>
                  <input type="text" class="form-control" v-model="buscar">
                <div class="input-group-btn input-group-append">
                  <div class="input-group-text" style="background-color: #234c8c; cursor: pointer; color: white;" @click="buscar=''"> X </div>
                </div>
                </div>
              </div>
              <table class="table table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Año</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Docente</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in cursos.filter(e => e.nombre.toUpperCase().indexOf(buscar.toUpperCase()) != -1 || e.docente.nombre.toUpperCase().indexOf(buscar.toUpperCase()) != -1)" :key=item.uid>
                    <td> {{item.anio.nombre}} </td>
                    <td> {{item.nombre}} </td>
                    <td> {{item.docente.nombre}} </td>
                    <td>
                      <button class="btn btn-warning" data-placement="bottom" title="Editar" data-toggle="modal" data-target="#ModalCurso" @click="seleccionar('curso', item)" style="height: 20px; font-size: 13px; padding-top: 0px; ">Edit</button>
                      <button class="btn btn-danger"  data-toggle="tooltip" data-placement="bottom" title="Eliminar" @click="eliminar('curso', item)"  style="height: 20px; font-size: 13px; padding-top: 0px; ">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </table>
                            <!-- Modal -->
              <div class="modal fade" id="ModalCurso" tabindex="-1" role="dialog" aria-labelledby="ModalCursoTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="ModalCursoTitle">
                        <div v-if="curso.uid == undefined">Agregar</div>
                        <div v-else>Modificar</div>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">

                      <form @submit.prevent="guardar('curso',curso.uid ? 'edit':'new',curso)">
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Nombre: </label>
                          <input class="form-control" type="text" v-model="curso.nombre">
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Año: </label>
                          <!-- <input class="form-control" type="number"> -->
                          <select class="form-control" name="" v-model="curso.anio">
                          <option v-for="itemAnio in ListaAnios" :key=itemAnio.uid :value="itemAnio">{{itemAnio.nombre}}</option>
                          </select>
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Docente: </label>
                          <!-- <input class="form-control" type="number"> -->
                          <select class="form-control" name="" v-model="curso.docente">
                          <option v-for="itemDocente in listaDocentes" :key=itemDocente.uid :value="itemDocente">{{itemDocente.nombre}}</option>
                          </select>
                        </div>
                        <br>
                        
                        <button type="submit" class="btn btn-primary" @click="spinner=!spinner">
                          <div v-if="!spinner"> Save changes </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                          </button> <br>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" id="closeCurso">Close</button>
                      </form>
                    </div>
                    <!-- <div class="modal-footer">
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="modal fade" id="ModalDuplicarCurso" tabindex="-1" role="dialog" aria-labelledby="ModalDuplicarCursoTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="ModalDuplicarCursoTitle">
                        <div>Duplicar</div>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">

                      <form @submit.prevent="copiarCursos()">
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Año Desde: </label>
                          <select class="form-control" name="" v-model="cursoDesde">
                          <option v-for="itemAnio in anios" :key=itemAnio.uid :value="itemAnio">{{itemAnio.nombre}}</option>
                          </select>
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Año Hasta: </label>
                          <select class="form-control" name="" v-model="cursoHasta">
                          <option v-for="itemAnio in anios" :key=itemAnio.uid :value="itemAnio">{{itemAnio.nombre}}</option>
                          </select>
                        </div>
                        <br>
                        
                        <button type="submit" class="btn btn-primary" @click="spinner=!spinner">
                          <div v-if="!spinner"> Save changes </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                          </button> <br>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" id="closeDuplicarCurso">Close</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-alumnos" role="tabpanel" aria-labelledby="pills-alumnos-tab">
              <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#ModalAlumno" @click="clear('alumno')">
                Agregar
              </button>
              <div class="col-4 filtro">
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Filtro</div>
                  </div>
                  <input type="text" class="form-control" v-model="buscar">
                <div class="input-group-btn input-group-append">
                  <div class="input-group-text" style="background-color: #234c8c; cursor: pointer; color: white;" @click="buscar=''"> X </div>
                </div>
                </div>
              </div>
              <table class="table table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">DNI</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in alumnos.filter(e => e.nombre.toUpperCase().indexOf(buscar.toUpperCase()) != -1 || e.dni.toUpperCase().indexOf(buscar.toUpperCase()) != -1 )" :key=item.uid>
                    <td> {{item.dni}} </td>
                    <td> {{item.nombre}} </td>
                    <td>
                      <button class="btn btn-warning" data-placement="bottom" title="Editar" data-toggle="modal" data-target="#ModalAlumno" @click="seleccionar('alumno', item);seleccionAlumno = item;" style="height: 20px; font-size: 13px; padding-top: 0px; ">Edit</button>
                      <button class="btn btn-danger"  data-toggle="tooltip" data-placement="bottom" title="Eliminar" @click="eliminar('alumno', item)" style="height: 20px; font-size: 13px; padding-top: 0px; ">Delete</button>
                      <!-- <button class="btn btn-primary" title="Observaciones" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="buscarObservacion(item.dni); agregarObservacion=false;">Observaciones</button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Modal -->
              <div class="modal fade" id="ModalAlumno" tabindex="-1" role="dialog" aria-labelledby="ModalAlumnoTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="ModalAlumnoTitle">
                        <div v-if="alumno.uid == undefined">Agregar</div>
                        <div v-else>Modificar</div></h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">

                      <form @submit.prevent="guardar('alumno',alumno.uid ? 'edit':'new',alumno)">
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">DNI: </label>
                          <input class="form-control" type="number" v-model="alumno.dni">
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Nombre: </label>
                          <input class="form-control" type="text" v-model="alumno.nombre">
                        </div>

                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Cursos: </label> 
                          <select class="form-control" name="" v-model="alumno.curso">
                          <option :value="{anio: '',docente: '',nombre:'',uid: 10000000 }"> Seleccionar para Borrar </option>  
                          <option v-for="itemCurso in cursosConfig" :key=itemCurso.uid :value="itemCurso">{{itemCurso.nombre}} - {{itemCurso.anio.nombre }} ({{itemCurso.docente.nombre}})</option>
                          </select>
                          <select class="form-control" name="" v-model="alumno.curso2">
                          <option :value="{anio: '',docente: '',nombre:'',uid: 10000000 }"> Seleccionar para Borrar </option>  
                          <option v-for="itemCurso in cursosConfig" :key=itemCurso.uid :value="itemCurso">{{itemCurso.nombre}} - {{itemCurso.anio.nombre }} ({{itemCurso.docente.nombre}})</option>
                          </select>
                        </div>
                        <!-- .filter(a => a.uid != alumno.curso2.uid) -->
                        <br>
                        
                        <button type="submit" class="btn btn-primary" @click="spinner=!spinner">
                          <div v-if="!spinner"> Save changes </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                          </button> <br>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" id="closeAlumno">Close</button>
                      </form>
                    </div>
                    <!-- <div class="modal-footer">
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-novedades" role="tabpanel" aria-labelledby="pills-novedades-tab">
              <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#ModalNovedad" @click="clear('novedad')">
                Agregar
              </button>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Date (Fecha)</th>
                      <th scope="col">Novedad (Novedad)</th>
                      <th scope="col">Accion</th>
                    </tr>
                  </thead>
                    <tbody v-for="(itemNovedades, index) in novedades" :key=index >
                      <tr>
                        <td> {{itemNovedades.fecha}} </td>
                        <!-- <td> {{itemNovedades.novedad}} </td> -->
                        <td :id="'Nov'+itemNovedades.uid+index"> {{verSaltoLinea('Nov'+itemNovedades.uid+index,itemNovedades.detalle, false )}} </td>

                        <td>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Edit" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="edit('novedad', itemNovedades)">edit</button>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Delete" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="eliminar('novedad', itemNovedades)">Delete</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
                            <!-- Modal -->
              <div class="modal fade" id="ModalNovedad" tabindex="-1" role="dialog" aria-labelledby="ModalNovedadTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="ModalNovedadTitle">
                        <div>Agregar</div>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="agregarNovedad= false;">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">

                      <form @submit.prevent="guardar('novedad','new',novedad)">
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Fecha: </label>
                          <input class="form-control" type="text" id="datepickerNovedad">
                        </div>
                        <div class="row m-auto mb-1 justify-content-center col-10">
                          <label for="">Novedad: </label>
                          <!-- <input class="form-control" type="text" v-model="observacion.detalle"> -->
                          <textarea v-model="novedad.detalle" rows="4" class="form-control" ></textarea>

                        </div>
                        <br>
                        <!-- <button type="submit" @keydown="$event.keyCode === 13 ? $event.preventDefault() : false" class="btn btn-primary"> -->
                        <button type="submit" class="btn btn-primary">
                          <div v-if="!spinner"> Save changes </div>
                          <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                          </button> <br>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="agregarNovedad= false;" id="closeNovedad">Close</button>
                      </form>
                    </div>
                    <!-- <div class="modal-footer">
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

      <button type="button" class="btn btn-primary mb-3 d-none" data-toggle="modal" data-target="#ErrorModal" id="ErrorModalBtn">
        ------
      </button>

        <!-- Modal -->
      <div class="modal fade" id="ErrorModal" tabindex="-1" role="dialog" aria-labelledby="ErrorModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="ErrorModalTitle">
                <div>{{msjErrorTitle}}</div>
                </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              {{msjErrorText}} <br>
                <button type="button" class="btn btn-secondary mt-4" data-dismiss="modal" id="closeAnio">Close</button>
            </div>
            <!-- <div class="modal-footer">
            </div> -->
          </div>
        </div>
      </div>

      <!-- Modal -->
      <!-- <div class="modal fade" id="ModalAlumnoObservaciones" tabindex="-1" role="dialog" aria-labelledby="ModalAlumnoObservacionesTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalAlumnoObservacionesTitle">
                <div>Observaciones </div>
                <div  v-if="Object.keys(seleccionAlumno).length != 0">
                {{seleccionAlumno.nombre}}
              </div></h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding-top: 0px;" >
              <div v-if="!agregarObservacion">
                <button class="btn btn-primary mb-2" @click="agregarObservacion=true; clear('observacion') ">Agregar</button>
                <table class="table" v-if="Object.keys(seleccionAlumno).length != 0">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Date (Fecha)</th>
                      <th scope="col">Detail (Detalle)</th>
                      <th scope="col">Accion</th>
                    </tr>
                  </thead>
                    <tbody v-for="(itemObservacion, index) in seleccionAlumno.observaciones.filter(n => n.uidCurso == cursoSeleccionado.uid)" :key=index >
                      <tr>
                        <td> {{itemObservacion.fecha}} </td>
                        <td :id="'Obs'+seleccionAlumno.dni+index"> {{verSaltoLinea('Obs'+seleccionAlumno.dni+index,itemObservacion.detalle, false )}} </td>
                        <td>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Edit" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="agregarObservacion=true; edit('observacion', itemObservacion)">Edit</button>
                          <button class="btn btn-primary"  data-toggle="tooltip" data-placement="bottom" title="Delete" style="height: 20px; font-size: 13px; padding-top: 0px;" @click="delObservacion({item:itemObservacion, alumno:seleccionAlumno})">Delete</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="ModalAlumnoObservacionesTitle">Close</button>
              </div>
              <div v-else>
                <form @submit.prevent="guardar('observacion','new',observacion)">
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Fecha: </label>
                    <input class="form-control" type="text" id="datepickerObservacion">
                  </div>
                  <div class="row m-auto mb-1 justify-content-center col-10">
                    <label for="">Observación: </label>
                    <textarea v-model="observacion.detalle" rows="4" class="form-control" ></textarea>
                  </div>
                  <br>
                  <button type="submit" class="btn btn-primary">
                    <div v-if="!spinner"> Save changes </div>
                    <div v-else class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    </button> <br>
                  <button type="button" class="btn btn-secondary" @click="agregarObservacion= false;">Close</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div> -->

    </div>
  </section>

</div> 

</template>

<script>

import { mapState, mapActions , mapGetters} from "vuex";
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'Docentes',
  data(){
    return {
      mostrarA: true,
      mostrarB: false,
      mostrarC: false,
      mostrarD: false,
      buscar:'',
      anio: {
        // uid:'',
        nombre:'',
        activo: true
      },
      docente: {
        dni:'',
        nombre:'',
        clave:'',
        activo: true,
        full: false
      },
      mostrarClave: false,
      curso: {
        nombre:'',
        anio: {},
        docente: {}
      },
      alumno: {
        dni: '',
        nombre: '',
        curso: {},
        curso2: {}
      },
      spinner: false,
      cursoSeleccionado: '',
      dni: '',
      clave:'',
      seleccionAlumno: {},
      agregarNota: false,
      agregarObservacion: false,
      agregarLibro: false,
      agregarNovedad: false,
      agregarCursoNovedad: false,
      nota: {
        fecha:'',
        oral:'',
        escrito:'',
        comentario:''
      },
      observacion: {
        fecha:'',
        detalle:''
      },
      libro: {
        nombre:'',
      },
      cursoNovedad: {
        fecha:'',
        detalle:''
      },
      msjErrorText:'',
      msjErrorTitle:'',
      novedad: {
        fecha:'',
        detalle:''
      },
      mostraDetalle : false,
      itemUpdate: '',
      selectAll: false,
      cursoDesde:'',
      cursoHasta:'',
      buscarAnio:''
    }
  },
  methods: {
    ...mapActions(['getAnios','addAnio','delAnio','putAnio',
                   'getDocentes','addDocente','delDocente','putDocente',
                   'getCursos', 'addCurso','delCurso','putCurso',
                   'getAlumnos','addAlumno','delAlumno','putAlumno','putUpgradeAlumno','addLecturaAlumnos','addHistorico',
                   'AlumnosCursos', 'ingresoDocente', 'cursosDocente',
                   'addNota','delNota', 'addObservacion', 'delObservacion',
                   'addLibro','delLibro', 'addCursoNovedad', 'delCursoNovedad',
                   'getNovedades', 'delNovedad', 'addNovedad','getLecturaAlumnos',
                   'buscarAlumnoConfig', 'putEditCursoAlumno'
                  ]),
    closeMenu(){
      var navbar = $(".navbar-collapse");
      navbar.removeClass('show');
    },
    verSaltoLinea(asd, tex, comentario){
      // console.log(asd);
      var c = "<b>Comentario: </b>";

      if(comentario){
        tex = c + ' ' + tex
      }
      setTimeout(() => {
        $('#'+asd).html(tex);
        
      }, 10);
    },
    delNotaConfirm(payload) {
      if (confirm('¿Seguro que querés eliminar esta nota?')) {
        this.delNota(payload);
      }
    },
    delObservacionConfirm(payload) {
      if (confirm('¿Seguro que querés eliminar esta observacion?')) {
        this.delObservacion(payload);
      }
    },
    guardar(categoria, tipo, item){
      if(categoria == 'anio'){
        if(tipo == 'new'){
          item.historico = false
          this.addAnio(item)
          .then(() => {
            this.clear('anio');
            $('#closeAnio').click()
          })
        }else{
          this.putAnio(item)
          .then(() => {
            this.clear('anio');
            $('#closeAnio').click()
          })
        }
      }
      if(categoria == 'docente'){
        if(tipo == 'new'){
          this.addDocente(item)
          .then(() => {
            this.clear('docente');
            $('#closeDocente').click()
          })
        }else{
          this.putDocente(item)
          .then(() => {
            this.clear('docente');
            $('#closeDocente').click()
          })
        }
      }
      if(categoria == 'curso'){
        if(tipo == 'new'){
          this.addCurso(item)
          .then(() => {
            this.clear('curso');
            $('#closeCurso').click()
          })
        }else{
          this.putCurso(item)
          .then(() => {
            this.clear('curso');
            $('#closeCurso').click()

            this.alumnos.filter(a => typeof(a.curso)!='undefined').filter(b => typeof(b.curso.uid)!='undefined'? b.curso.uid == item.uid : null).forEach( a => {
              console.log("ACAAAAAAA Edit")
              console.log(a)
              this.putEditCursoAlumno({alumno:a, cursoActual: null, curso:item})
            })
            this.alumnos.filter(a => typeof(a.curso2)!='undefined').filter(b => typeof(b.curso2.uid)!='undefined'? b.curso2.uid == item.uid : null).forEach( a => {
              console.log("ACAAAAAAA Edit")
              console.log(a)
              this.putEditCursoAlumno({alumno:a, cursoActual: null, curso:item})
            })
          })
        }
      }
      if(categoria == 'alumno'){
        if(tipo == 'new'){
          var mismo = false
          var busqueda = this.alumnos.filter(a => a.dni == item.dni)
          if(busqueda.length == 0){
              // item.curso.notas =[];
              // item.curso.observaciones =[]
              // item.novedades= []
              if(item.curso != undefined)
              { 
                if(item.curso.uid == 10000000){ item.curso = {}}
              }
              if(item.curso2 != undefined)
              { 
                if(item.curso2.uid == 10000000){ item.curso2 = {}}
              }

              if(item.curso.uid != 'undefined' && item.curso2.uid != 'undefined'){
                if(item.curso.uid == item.curso2.uid){
                  mismo = true
                }
              }
              if(!mismo){
                this.addAlumno(item)
                .then(() => {
                  this.clear('alumno');
                  $('#closeAlumno').click()
                })
              }else{
                this.spinner= false
                alert('Error al seleccionar el mismo Curso')
              }
          }else{
            this.spinner= false
            alert('Ese DNI ya fue cargado')
          }
        }else{
          var mismo = false
          var busqueda = this.alumnos.filter(a => a.dni == item.dni && a.uid != item.uid)
          if(busqueda.length == 0){
              if(item.curso != undefined)
              { 
                if(item.curso.uid == 10000000){ item.curso = {}}
              }
              if(item.curso2 != undefined)
              { 
                if(item.curso2.uid == 10000000){ item.curso2 = {}}
              } 

              if(typeof(item.curso.uid) != 'undefined' && typeof(item.curso2.uid) != 'undefined'){
                if(item.curso.uid == item.curso2.uid){
                  mismo = true
                }
              }

              if(this.seleccionAlumno.notas){
                item.notas = [];
                this.seleccionAlumno.notas.forEach(n =>{
                  if ( n.uidCurso == this.seleccionAlumno.curso.uid){
                    item.notas.push({
                      uidCurso: item.curso.uid,
                      fecha: n.fecha,
                      oral:n.oral,
                      escrito:n.escrito,
                      comentario:n.comentario
                      })
                    }
                  if ( n.uidCurso == this.seleccionAlumno.curso2.uid){
                      item.notas.push({
                      uidCurso: item.curso2.uid,
                      fecha: n.fecha,
                      oral:n.oral,
                      escrito:n.escrito,
                      comentario:n.comentario
                      })
                    }
                  })
                }
              
              if(this.seleccionAlumno.observaciones){
                  item.observaciones = [];
                  this.seleccionAlumno.observaciones.forEach(n =>{
                    if ( n.uidCurso == this.seleccionAlumno.curso.uid){
                      item.observaciones.push({
                        uidCurso: item.curso.uid,
                        fecha: n.fecha,
                        detalle:n.detalle,
                        })
                    }
                    if ( n.uidCurso == this.seleccionAlumno.curso2.uid){
                      item.observaciones.push({
                        uidCurso: item.curso2.uid,
                        fecha: n.fecha,
                        detalle:n.detalle,
                        })
                    }
                  })
              }

              if(!mismo){
                console.log('UPDATE')
                console.log(item)
                this.putAlumno(item)
                .then(() => {
                  this.clear('alumno');
                  $('#closeAlumno').click()
                })
              }else{
                  this.spinner= false
                  alert('Error al seleccionar el mismo Curso')
                }
          }else{
            this.spinner= false
            alert('Ese DNI ya fue cargado')
          }
        }
      }
      if(categoria == 'nota'){
        var add = true
        var aux = {
          fecha : '',
          oral: '',
          escrito: '',
          comentario: ''
        }
        
        this.spinner= true;
        item.fecha = $("#datepickerNota").val();

        aux.fecha = item.fecha;
        aux.oral = item.oral;
        aux.escrito = item.escrito;
        aux.comentario = item.comentario.replace(/\r\n|\n\r|\r|\n/gi, " <br> ");

        if(this.seleccionAlumno.notas){
          this.seleccionAlumno.notas.forEach(n =>{
            // console.log(n);
            // console.log(object);
            if ( n.fecha == aux.fecha && n.oral == aux.oral && n.escrito == aux.escrito && n.comentario == aux.comentario && n.uidCurso == this.cursoSeleccionado.uid){
              add = false
              alert('Nota ya ingresada!!')
              this.spinner= false
            }
            //console.log(n);
            //console.log(this.cursoSeleccionado)
          })
        }

          if(add){
            this.addNota({item: aux, alumno: this.seleccionAlumno, curso : this.cursoSeleccionado})
            .then(() => {
              if (this.itemUpdate != '') this.delNota({item:this.itemUpdate, alumno:this.seleccionAlumno, curso : this.cursoSeleccionado})

              this.clear('nota');
              // $('#closeCurso').click()
              this.agregarNota= false;
            })
          }
      }
      if(categoria == 'observacion'){
        var add = true
        var aux = {
          fecha : '',
          detalle: ''
        }
        this.spinner= true;
        item.fecha = $("#datepickerObservacion").val();
        // item.detalle = item.detalle.replace(/\r\n|\n\r|\r|\n/gi, " <br> ");

        aux.fecha = $("#datepickerObservacion").val();
        aux.detalle = item.detalle.replace(/\r\n|\n\r|\r|\n/gi, " <br> ");

        if(this.seleccionAlumno.observaciones){
          this.seleccionAlumno.observaciones.forEach(n =>{
            // console.log(n);
            // console.log(object);
            if ( n.fecha == aux.fecha && n.detalle == aux.detalle){
              add = false
              alert('Observacion ya ingresada!!')
              this.spinner= false
            }
          })
        }

          if(add){
            this.addObservacion({item: aux, alumno: this.seleccionAlumno, curso : this.cursoSeleccionado})
            .then(() => {
              if (this.itemUpdate != '') {
                this.delObservacion({item:this.itemUpdate, alumno:this.seleccionAlumno, curso : this.cursoSeleccionado}).then(()=>{
                  this.clear('observacion');
                  this.agregarObservacion= false;
                })
              }else{
                this.clear('observacion');
                this.agregarObservacion= false;
              }
            })
          }
      }
      if(categoria == 'libro'){
        var add = true
        this.spinner= true;

        if(this.cursoSeleccionado.libros){
          this.cursoSeleccionado.libros.forEach(n =>{
            if ( n.nombre == item.nombre){
              add = false
              alert('Libro ya ingresado!!')
              this.spinner= false
            }
          })
        }

          if(add){
            this.addLibro({item, curso: this.cursoSeleccionado})
            .then(() => {
              if (this.itemUpdate != '') {
                this.delLibro({item:this.itemUpdate, curso:this.cursoSeleccionado}).then(()=>{
                  this.clear('libro');
                  this.agregarLibro= false;
                })
              }else{
                this.clear('libro');
                this.agregarLibro= false;
              }
            })
          }
      }
      if(categoria == 'cursoNovedad'){
        var add = true
        var aux = {
          fecha : '',
          novedad: ''
        }

        this.spinner= true;
        item.fecha = $("#datepickerCursoNovedad").val();

        aux.fecha = item.fecha;
        aux.novedad = item.novedad.replace(/\r\n|\n\r|\r|\n/gi, " <br> ");

        if(this.cursoSeleccionado.novedades){
          this.cursoSeleccionado.novedades.forEach(n =>{
            if ( n.fecha == aux.fecha && n.novedad == aux.novedad){
              add = false
              alert('Novedad ya ingresada!!')
              this.spinner= false
            }
          })
        }

        if(add){
          this.addCursoNovedad({item: aux, curso: this.cursoSeleccionado})
          .then(() => {
            if (this.itemUpdate != '') {
              this.delCursoNovedad({item:this.itemUpdate, curso: this.cursoSeleccionado}).then(()=>{
                this.clear('cursoNovedad');
                this.agregarCursoNovedad= false;
              })
            }else{
              this.clear('cursoNovedad');
              this.agregarCursoNovedad= false;
            }
          })
        }
      }
      if(categoria == 'novedad'){
        if(tipo == 'new'){
          var add = true
          var aux = {
            fecha : '',
            detalle: ''
          }

          this.spinner= true;
          item.fecha = $("#datepickerNovedad").val();

          aux.fecha = item.fecha;
          aux.detalle = item.detalle.replace(/\r\n|\n\r|\r|\n/gi, " <br> ");

          if(this.novedades){
            this.novedades.forEach(n =>{
              if ( n.fecha == aux.fecha && n.detalle == aux.detalle){
                add = false
                alert('Novedad ya ingresada!!')
                this.spinner= false
              }
            })
          }
        if(add){
          this.addNovedad(aux)
          .then(() => {
            if (this.itemUpdate != '') {
              this.delNovedad(this.itemUpdate.uid).then(()=>{
                this.clear('novedad');
                this.agregarNovedad= false;
                $("#ModalNovedad").modal("hide");
              })
            }else{
              this.clear('novedad');
              this.agregarNovedad= false;
              $("#ModalNovedad").modal("hide");
            }
          })
        }

        }
      }
    },
    eliminar(categoria, item){
      if(categoria == 'anio'){
        if (confirm('¿Seguro que querés eliminar este año?')) {
        this.delAnio(item.uid)
      }
      }
      if(categoria == 'docente'){
        if (confirm('¿Seguro que querés eliminar este docente?')) {
        this.delDocente(item.uid)
      }

      }
      if(categoria == 'curso'){
        var cantidadC1
        var cantidadC2
        cantidadC1 = this.alumnos.filter(a => typeof(a.curso)!='undefined').filter(b => typeof(b.curso.uid)!='undefined'? b.curso.uid == item.uid : null)
        cantidadC2 = this.alumnos.filter(a => typeof(a.curso2)!='undefined').filter(b => typeof(b.curso2.uid)!='undefined'? b.curso2.uid == item.uid : null)
        if((cantidadC1.length + cantidadC2.length) == 0){
          if (confirm('¿Seguro que querés eliminar este curso?')) {
            this.delCurso(item.uid)
          }
          }else{
            alert('Este Curso tiene alumnos asignados')
        }
      }
      if(categoria == 'alumno'){
        if (confirm('¿Seguro que querés eliminar este alumno?')) {
        this.delAlumno(item.uid)
      }
      }   
      if(categoria == 'novedad'){
        if (confirm('¿Seguro que querés eliminar esta novedad?')) {
        this.delNovedad(item.uid)
      }
      }     

    },
    seleccionar(categoria, item){
      if(categoria == 'anio'){
        this.clear(categoria)
        this.anio.uid = item.uid.toString();
        this.anio.nombre = item.nombre.toString();
        this.anio.activo = item.activo;
        this.anio.historico = item.historico;
      }
      if(categoria == 'docente'){
        this.clear(categoria)
        this.docente.uid = item.uid.toString();
        this.docente.dni = item.dni.toString();
        this.docente.nombre = item.nombre.toString();
        this.docente.clave = item.clave.toString();
        this.docente.activo = item.activo == true ? true : false;
        this.docente.full = item.full == true ? true : false;
      }
      if(categoria == 'curso'){
        this.clear(categoria)
        this.curso.uid = item.uid.toString();
        this.curso.nombre = item.nombre.toString();
        this.curso.anio = item.anio;
        this.curso.docente = item.docente;
      }
      if(categoria == 'alumno'){
        this.clear(categoria)
        this.alumno.uid = item.uid.toString();
        this.alumno.dni = item.dni.toString();
        this.alumno.nombre = item.nombre.toString();
        this.alumno.curso = typeof(item.curso) == 'undefined' ? {} : item.curso;
        this.alumno.curso2 = typeof(item.curso2) == 'undefined' ? {} : item.curso2;
      }
    },
    clear(categoria){
      this.itemUpdate = ''
      if(categoria == 'anio'){
        this.anio = {
          nombre: '',
          activo: true
        }
      }
      if(categoria == 'docente'){
        this.docente = {
          dni:'',
          nombre:'',
          clave:'',
          activo: true,
          full: false
        }
        this.mostrarClave = false
      }
      if(categoria == 'curso'){
        this.curso = {
          nombre:'',
          anio: {},
          docente: {}
        }
        this.mostrarClave = false
      }
      if(categoria == 'duplicarCurso'){
        this.cursoDesde = ''
        this.cursoHasta = ''
      }
      if(categoria == 'alumno'){
        this.alumno = {
          dni:'',
          nombre: '',
          curso: {},
          curso2: {}
        }
        this.mostrarClave = false
      }
      if(categoria == 'nota'){
        this.nota = {
          fecha:'',
          oral:'',
          escrito:'',
          comentario: ''
        }
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerNota").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date());;
        }, 500);
      }
      if(categoria == 'observacion'){
        this.observacion = {
          fecha:'',
          detalle:''
        }
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerObservacion").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date());
        }, 500);
      }
      if(categoria == 'libro'){
        this.libro = {
          nombre:''
        }
      }
      if(categoria == 'cursoNovedad'){
        this.cursoNovedad = {
          fecha:'',
          novedad:''
        }
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerCursoNovedad").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date());
        }, 500);
      }
      if(categoria == 'novedad'){
        this.novedad = {
          fecha:'',
          detalle:''
        }
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerNovedad").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date());
        }, 500);
      }

      this.spinner= false
    },
    edit(categoria, item){
      this.itemUpdate = ''
      if(categoria == 'nota'){
        this.nota = {
          fecha: item.fecha.toString(),
          oral: item.oral.toString(),
          escrito: item.escrito.toString(),
          comentario: item.comentario.replace(/<br> /gi, "\r\n").toString()
        }
        this.itemUpdate = item
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerNota").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date(item.fecha)).val(item.fecha)
        }, 500);
      }
      if(categoria == 'observacion'){
        this.observacion = {
          fecha: item.fecha.toString(),
          detalle: item.detalle.replace(/<br> /gi, "\r\n").toString()
        }
        this.itemUpdate = item
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerObservacion").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date(item.fecha)).val(item.fecha)
        }, 500);
      }
      if(categoria == 'libro'){
        this.libro = {
          nombre: item.nombre
        }
        this.itemUpdate = item
      }
      if(categoria == 'cursoNovedad'){
        this.cursoNovedad = {
          fecha: item.fecha.toString(),
          novedad: item.novedad.replace(/<br> /gi, "\r\n").toString()
        }
        this.itemUpdate = item
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerCursoNovedad").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date(item.fecha)).val(item.fecha)
        }, 500);
      }
      if(categoria == 'novedad'){
        $("#ModalNovedad").modal("show");
        this.novedad = {
          fecha: item.fecha.toString(),
          detalle: item.detalle.replace(/<br> /gi, "\r\n").toString()
        }
        this.itemUpdate = item
        setTimeout(function(){ 
          $.datepicker.setDefaults($.datepicker.regional['es']);
          $("#datepickerNovedad").datepicker({     firstDay: 1     })
          .datepicker("setDate", new Date(item.fecha)).val(item.fecha)
        }, 500);
      }

      this.spinner= false
    },
    async buscarAlumnos(itemCursouid){
      this.cursoSeleccionado = this.cursos.filter(p => p.uid == itemCursouid)[0] // itemCursouid.toString();
      await this.AlumnosCursos(itemCursouid)
      $.datepicker.setDefaults($.datepicker.regional['es']);
      this.selectAll = false
    },
    marcar(item){
      this.alumnosCurso.forEach( a =>{
        a.select = item
      })
    },
    ingreso(){
      this.spinner= true;
      this.ingresoDocente({dni:this.dni, clave:this.clave}).then(()=>{
          if(this.docenteIngreso.length > 0){

            if(this.docenteIngreso[0].activo){
              this.mostrarA=false;
              this.mostrarB=true; 
              this.mostrarC=false; 
              // this.docenteIngreso = this.docenteIngreso[0];
              this.getAnios();
              
              if(this.docenteIngreso[0].full){
                this.getDocentes();
                this.getCursos();
              }else{
                this.cursosDocente(this.docenteIngreso[0].uid)
              }
            }else{
              this.msjErrorTitle = 'Ingreso Docente';
              this.msjErrorText = 'El usuario no esta activo.';
              $('#ErrorModalBtn').click()
            }
        }else{
          this.msjErrorTitle = 'Ingreso Docente';
          this.msjErrorText = 'El usuario y/o contraseña es incorrecta. Si el problema continua comunicarme con Secretaria.';
          $('#ErrorModalBtn').click()
          // alert('Error Ingreso')
        }
        this.spinner= false;
      })
    },
    generarPDF(){
          const doc = new jsPDF("p", "pt", "a4")

          // overall margin
          const margin = {
            left: 15,
            right: 15,
            top: 20,
            bottom: 20,
          };

          // number of table sections in the page
          const sections = 1;

          // space between each table
          const spacing = 5;

          // calculate each section width
          const printWidht = doc.internal.pageSize.width - (margin.left + margin.right);
          const sectionWidth = (printWidht - ((sections - 1) * spacing)) / sections;

          // add an initial empty page that will be delete later,
          // it is needed for the first setPage(previous_page) call
          doc.addPage();
          let currentSection;
          let nextSection = 1;
          let startY = margin.top;
          
          doc.setFontSize(20); // seteo para que la fuente sea de 20px;
          doc.text(this.cursoSeleccionado.nombre, 300, 30, {
              align: "center"
          });

          var columnsNotas = [
            { title: "Date", dataKey: "fecha" },
            { title: "Oral", dataKey: "oral" },
            { title: "Written", dataKey: "escrito" }
          ];
          var columnsObs = [
            { title: "Date", dataKey: "fecha" },
            { title: "Detail", dataKey: "detalle" }
          ];

          var Height
          startY += 60
          this.alumnosCurso.forEach(a =>{

              var arrayNotas=[];


              if(a.notas != undefined && a.notas.length > 0){
                a.notas.forEach(n => {
                  arrayNotas.push({
                    fecha: n.fecha ,
                    oral: n.oral,
                    escrito: n.escrito
                  })
                  if(n.comentario){
                    arrayNotas.push({
                      fecha: //n.comentario.replace(/<br> /gi, "\r\n"),            
                      {content: 'Comentario: '+n.comentario.replace(/<br> /gi, "\r\n"),
                      colSpan: 3,
                      // styles: { halign: 'center', fillColor: [22, 160, 133] }
                      }
                    })
                  }
                })
              }

            var arrayObs=[];


            if(a.observaciones != undefined && a.observaciones.length > 0){
              a.observaciones.forEach(n => {
                var detail = n.detalle.replace(/<br> /gi, "\r\n")
                arrayObs.push({
                  fecha: n.fecha,
                  detalle: detail
                })
              })
            }

            doc.text(a.nombre , 40, startY)
            startY += 10
            // var Height  = 0
            var remainingVSpace

            // if(a.notas != undefined && a.notas.length > 0){

              doc.autoTable({ 
                styles: { halign: 'center' },
                head: [
                        [
                          {
                            content: 'Notas',
                            colSpan: 3,
                            styles: { halign: 'center', fillColor: [35,76,140] },
                          },
                        ],
                      ],
                theme: 'grid',
                headStyles: { fillColor: [35,76,140], halign: 'center' },
                // styles: { cellPadding: 0.5, fontSize: 8, halign: 'center' },
                // html: '#Tabla'+c.id,
                tableWidth: sectionWidth,
                margin: {
                  left: margin.left + ((nextSection - 1) * (sectionWidth + spacing)),
                  top: margin.top,
                  bottom: margin.bottom,
                },
                startY,
                rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
                didDrawPage({table, pageNumber, pageCount}) {
                  currentSection = nextSection;
                  nextSection = (nextSection % sections) + 1;
  
                  // set left margin which will controll x position of next section
                  const shift = (nextSection - 1) * (sectionWidth + spacing)
                  table.settings.margin.left = margin.left + shift;
  
                  // if next section is not the fist, move to previous page so when
                  // autoTable calls addPage() it will still be the same current page
                  if (nextSection > 1) {
                    doc.setPage(doc.internal.getNumberOfPages() - 1);
                  }
                },
                didDrawCell: function (HookData) {
                      console.log(HookData);
                      console.log(HookData.table.height );
                      Height = HookData.table.height
                      // var leftMargin = data.settings.margin.left
                      // height = HookData.table.height
                    }
              });
              startY += Height
  
              doc.autoTable(columnsNotas,arrayNotas,{ 
                styles: { halign: 'center' },
                // styles: { cellPadding: 0.5, fontSize: 8, halign: 'center' },
                // html: '#Tabla'+c.id,
                tableWidth: sectionWidth,
                theme: 'grid',
                headStyles: { fillColor: [93,120,214], halign: 'center' },
                margin: {
                  left: margin.left + ((nextSection - 1) * (sectionWidth + spacing)),
                  top: margin.top,
                  bottom: margin.bottom,
                },
                startY,
                rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
                didDrawPage({table, pageNumber, pageCount}) {
                  currentSection = nextSection;
                  nextSection = (nextSection % sections) + 1;
  
                  // set left margin which will controll x position of next section
                  const shift = (nextSection - 1) * (sectionWidth + spacing)
                  table.settings.margin.left = margin.left + shift;
  
                  // if next section is not the fist, move to previous page so when
                  // autoTable calls addPage() it will still be the same current page
                  if (nextSection > 1) {
                    doc.setPage(doc.internal.getNumberOfPages() - 1);
                  }
                }
              })
  
              // activate last page for further printing
              doc.setPage(doc.internal.getNumberOfPages());
  
              // if there's remaining vertical space in page: start printing next table from the current section
              remainingVSpace = doc.internal.pageSize.height - margin.bottom - doc.lastAutoTable.finalY;
              console.log(remainingVSpace);
              if (remainingVSpace > 46) {
                nextSection = currentSection;
                startY = doc.lastAutoTable.finalY + 20;
              } else {
                startY = margin.top;
                if (nextSection == 1) doc.addPage();
              }
            // }else{
            //   startY += 10
            // }

            if(a.observaciones != undefined && a.observaciones.length > 0){

              doc.autoTable({ 
                styles: { halign: 'center' },
                head: [
                        [
                          {
                            content: 'Observaciones',
                            colSpan: 2,
                            styles: { halign: 'center', fillColor: [35,76,140] },
                          },
                        ],
                      ],
                theme: 'grid',
                headStyles: { fillColor: [35,76,140], halign: 'center' },
                // styles: { cellPadding: 0.5, fontSize: 8, halign: 'center' },
                // html: '#Tabla'+c.id,
                tableWidth: sectionWidth,
                margin: {
                  left: margin.left + ((nextSection - 1) * (sectionWidth + spacing)),
                  top: margin.top,
                  bottom: margin.bottom,
                },
                startY,
                rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
                didDrawPage({table, pageNumber, pageCount}) {
                  currentSection = nextSection;
                  nextSection = (nextSection % sections) + 1;

                  // set left margin which will controll x position of next section
                  const shift = (nextSection - 1) * (sectionWidth + spacing)
                  table.settings.margin.left = margin.left + shift;

                  // if next section is not the fist, move to previous page so when
                  // autoTable calls addPage() it will still be the same current page
                  if (nextSection > 1) {
                    doc.setPage(doc.internal.getNumberOfPages() - 1);
                  }
                },
                didDrawCell: function (HookData) {
                      console.log(HookData);
                      console.log(HookData.table.height );
                      Height = HookData.table.height
                      // var leftMargin = data.settings.margin.left
                      // height = HookData.table.height
                    }
              });
              startY += Height

              doc.autoTable(columnsObs,arrayObs,{ 
                styles: { halign: 'center' },
                // styles: { cellPadding: 0.5, fontSize: 8, halign: 'center' },
                // html: '#Tabla'+c.id,
                tableWidth: sectionWidth,
                theme: 'grid',
                headStyles: { fillColor: [93,120,214], halign: 'center' },
                margin: {
                  left: margin.left + ((nextSection - 1) * (sectionWidth + spacing)),
                  top: margin.top,
                  bottom: margin.bottom,
                },
                startY,
                rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
                didDrawPage({table, pageNumber, pageCount}) {
                  currentSection = nextSection;
                  nextSection = (nextSection % sections) + 1;

                  // set left margin which will controll x position of next section
                  const shift = (nextSection - 1) * (sectionWidth + spacing)
                  table.settings.margin.left = margin.left + shift;

                  // if next section is not the fist, move to previous page so when
                  // autoTable calls addPage() it will still be the same current page
                  if (nextSection > 1) {
                    doc.setPage(doc.internal.getNumberOfPages() - 1);
                  }
                }
              })

              // activate last page for further printing
              doc.setPage(doc.internal.getNumberOfPages());

              // if there's remaining vertical space in page: start printing next table from the current section
              remainingVSpace = doc.internal.pageSize.height - margin.bottom - doc.lastAutoTable.finalY;
              console.log(remainingVSpace);
              if (remainingVSpace > 46) {
                nextSection = currentSection;
                startY = doc.lastAutoTable.finalY + 20;
              } else {
                startY = margin.top;
                if (nextSection == 1) doc.addPage();
              }
    
            }else{
              // startY += 10
            }

          })
          // delete unused empty page
          doc.deletePage(1)
          
          doc.save('table.pdf')
    },
    async buscarObservacion(dni){

      console.time('Tiempo Ejecucion')
      // this.$data.alumnoData = {}
      // console.log(this.alumnoData);
      // var aux = 
      await this.buscarAlumnoConfig(dni).then((a)=>{
        // console.log(a);
        this.seleccionAlumno = this.alumnoData
        $("#ModalAlumnoObservaciones").modal("show");
      })
      // console.log(this.alumnoData);
      console.timeEnd('Tiempo Ejecucion')


    },
    copiarCursos(){

      
      // this.cursoHasta
      // Agregar validaciones
      var Cursos
      var Hasta
      Cursos = this.cursos.filter(c => c.anio.uid == this.cursoDesde.uid)
      Hasta = {
        'uid': this.cursoHasta.uid,
        'nombre': this.cursoHasta.nombre
      }
      // delete this.cursoHasta.activo

      Cursos.forEach( c => {

        var d = {
          nombre : c.nombre,
          anio : Hasta,
          docente : c.docente == undefined? {} : c.docente,
          libros : c.libros == undefined? [] : c.libros,
          novedades : []
        }
        // c.anio = Desde
        // c.novedades = []
        // delete c.uid

        this.addCurso(d)
        .then(() => {
          this.clear('duplicarCurso');
          $('#closeDuplicarCurso').click()
        })

      })


    },
    upgrade(){

      if(this.cursoHasta!=''){
        var seleccionado = false
         this.spinner= true
        this.alumnosCurso.forEach( a => {
          if (a.select) {
            seleccionado = true
            console.log("ACAAAAAAA")
            console.log(a)
            this.putUpgradeAlumno({alumno:a, cursoActual: this.cursoSeleccionado, curso:this.cursoHasta})
          }
        })
        if(seleccionado){
          this.getLecturaAlumnos().then(()=>{
            this.addLecturaAlumnos().then(()=>{
              this.buscarAlumnos(this.cursoSeleccionado.uid).then(()=>{
                this.spinner= false
                $("#ModalUpgrade").modal("hide");
              })
            })
          })
        }else{
          this.spinner= false
          alert('Debe seleccionar un Alumnos!!')
        }
      }else{
        alert('Debe seleccionar un Curso!!')
      }
      
    },
    async historico(item){
      await this.getLecturaAlumnos().then(()=>{
        })
      var A 
      A = await this.alumnos.filter(a => a.curso.anio.uid == item.uid)
      await this.addHistorico({item:item, A:A}).then(()=>{
        item.historico = true
        this.putAnio(item)
      })
    }
  },
  computed: {
    ...mapState(['anios', 'ListaAnios', 'docentes', 'cursos', 'alumnos', 'listaDocentes','alumnosCurso', 'docenteIngreso', 'cursosConfig', 'novedades', 'alumnoData'])
  },
  created() {
    console.log('created');
    // this.getAnios();
    // this.getDocentes();
    // this.getCursos();
    // this.getAlumnos();

    $.datepicker.regional['es'] = {
      closeText: 'Cerrar',
      prevText: '<Ant',
      nextText: 'Sig>',
      currentText: 'Hoy',
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene','Feb','Mar','Abr', 'May','Jun','Jul','Ago','Sep', 'Oct','Nov','Dic'],
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Dom','Lun','Mar','Mié','Juv','Vie','Sáb'],
      dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sá'],
      weekHeader: 'Sm',
      dateFormat: 'dd/mm/yy',
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ''
      };
      $.datepicker.setDefaults($.datepicker.regional['es']);


  },
  beforeCreate() {
    console.log('beforeCreate');

    $.datepicker.regional['es'] = {
      closeText: 'Cerrar',
      prevText: '<Ant',
      nextText: 'Sig>',
      currentText: 'Hoy',
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene','Feb','Mar','Abr', 'May','Jun','Jul','Ago','Sep', 'Oct','Nov','Dic'],
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Dom','Lun','Mar','Mié','Juv','Vie','Sáb'],
      dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sá'],
      weekHeader: 'Sm',
      dateFormat: 'dd/mm/yy',
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ''
      };
      $.datepicker.setDefaults($.datepicker.regional['es']);
  },
  mounted() {
    console.log('mounted');

    

  },
}
</script>

